import React, { useState } from "react";
import { environmentalURL } from "../environmentalURL";

import "./FooterSection.css";

import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaXTwitter,
  FaChevronDown,
} from "react-icons/fa6";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ChatWithUs from "./ChatWithUs";

const FooterSection = () => {
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState(null);
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  // Phone: open the store directly (our smart link sends Android -> Play Store,
  // iPhone/iPad -> App Store). Desktop: show the page with the QR codes.
  const handleScannerClick = () => {
    const isMobile =
      /android|iphone|ipad|ipod/i.test(navigator.userAgent) ||
      window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      window.location.href = `${environmentalURL}/r/app`;
    } else {
      navigate("/generaterq");
    }
  };

  // Smart QR from our own backend: encodes {environmentalURL}/r/app, which sends
  // Android -> Play Store and iPhone/iPad -> App Store. If the API is unreachable the
  // image is hidden (the old bundled qr.png points to the dead paid service).
  const QR_SRC = `${environmentalURL}/r/api/qr`;

  return (
    <footer className="footer-container">
      {/* Top Row: 5 Columns */}
      <div className="footer-topRow">
        {/* Column 1 */}
        <div className="footer-column">
          <h4
            className="footer-heading"
            onClick={() => toggleSection("headOffice")}
          >
            Head Office <FaChevronDown className="chevron-icon" />
          </h4>
          <div
            className={`footer-content ${
              openSection === "headOffice" ? "open" : ""
            }`}
          >
            <p>Transaction Analysts India Pvt Ltd</p>
            <p>1st floor, Satyam Arcade, 4,</p>
            <p>BTM 2nd Stage, BTM Layout,</p>
            <p>Bengaluru, Karnataka - 560076</p>
         
          </div>
        </div>

        {/* Column 2 */}
        <div className="footer-column">
          <h4
            className="footer-heading"
            onClick={() => toggleSection("bbps")}
          >
            BBPS Business <FaChevronDown className="chevron-icon" />
          </h4>
          <ul
            className={`footer-content ${
              openSection === "bbps" ? "open" : ""
            }`}
          >
            <li>Mobile Postpaid</li>
            <li>DTH (Satellite TV)</li>
            <li>Municipal Taxes</li>
            <li>Credit Card Bills</li>
            <li>FASTag Recharge</li>
            <li>Subscription Fees</li>
            <li>Electricity Bill</li>
            <li>LPG Booking</li>
          </ul>
        </div>

        {/* Column 3 */}
        <div className="footer-column">
          <h4
            className="footer-heading"
            onClick={() => toggleSection("cards")}
          >
            Cards <FaChevronDown className="chevron-icon" />
          </h4>
          <ul
            className={`footer-content ${
              openSection === "cards" ? "open" : ""
            }`}
          >
            <li>Meals Card</li>
            <li>Telecom Card</li>
            <li>Gift Card</li>
            <li>Travel Card</li>
            <li>Rupay Card</li>
            <li>Virtual Card</li>
            <li>Fuel Card</li>
            <li>Physical Card</li>
          </ul>
        </div>

        {/* Column 4 */}
           <div className="footer-column">
              <h4 className="footer-heading">Contact</h4>
              <p>
                <FaPhoneAlt /> +91-9390358339
              </p>
              <p style={{ fontSize: "14px" }}>
                <FaEnvelope /> support@taipl.in
              </p>
            </div>
        {/* <div className="footer-column">
          <h4
            className="footer-heading"
            onClick={() => toggleSection("services")}
          >
            Services <FaChevronDown className="chevron-icon" />
          </h4>
          <ul
            className={`footer-content ${
              openSection === "services" ? "open" : ""
            }`}
          >
            <li>Wallet Features</li>
            <li>Merchant Solutions</li>
            <li>Government Schemes</li>
            <li>Bill Payments</li>
          </ul>

          <h4
            className="footer-heading"
            onClick={() => toggleSection("company")}
          >
            Company <FaChevronDown className="chevron-icon" />
          </h4>
          <div
  className={`footer-content ${
    openSection === "company" ? "open" : ""
  }`}
>
  <p style={{ cursor: "pointer" }} onClick={() => navigate("/aboutus")}>
    About
  </p>

  <p style={{ cursor: "pointer" }} onClick={() => navigate("/career")}>
    Career
  </p>
</div>
        </div> */}

        {/* Column 5 */}
        {/* <div className="footer-column">
          <h4
            className="footer-heading"
            onClick={() => toggleSection("support")}
          >
            Support <FaChevronDown className="chevron-icon" />
          </h4>
          <ul
            className={`footer-content ${
              openSection === "support" ? "open" : ""
            }`}
          >
            <li>Help Center</li>
            <li>User Guide</li>
            <li>Privacy Policy</li>
            <li>Terms of Service</li>
          </ul>
        </div> */}
      </div>

      {/* Middle Row */}
      <div className="footer-middleRow">
        <div className="footer-logo-wrap">
          <img
            src="/assets/images/TransactionAnalysts.png"
            alt="Transaction Analysts Logo"
            className="footer-logo-img"
          />
        </div>

        <div className="certifications-wrapper">
          <h6 className="certifications-heading">
            Certifications & Compliance
          </h6>
          <div className="cert-boxes">
            <div className="cert-card">
              <img
                src="/assets/images/certificate4.jpg"
                alt="ISO 27001:2013"
                className="cert-img"
              />
            </div>
            <div className="cert-card">
              <img
                src="/assets/images/certificate5.png"
                alt="NPCI Approved"
                className="cert-img"
              />
            </div>
            <div className="cert-card">
              <img
                src="/assets/images/certificate6.png"
                alt="RBI Compliant"
                className="cert-img"
              />
            </div>
          </div>
        </div>
<div className="social-icons">
  
  <a
    href="https://www.facebook.com/photo/?fbid=167322438522555&set=a.167322405189225"
    target="_blank"
    rel="noopener noreferrer"
    className="icon-circle"
  >
    <FaFacebookF />
  </a>

  <a
    href="https://x.com/ta_wallet"
    target="_blank"
    rel="noopener noreferrer"
    className="icon-circle"
  >
    <FaXTwitter />
  </a>

  <a
    href="https://www.instagram.com/transactionanalysts?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D"
    target="_blank"
    rel="noopener noreferrer"
    className="icon-circle"
  >
    <FaInstagram />
  </a>

  <a
    href="https://www.youtube.com/@TransactionAnalystsIndiaPvtLtd"
    target="_blank"
    rel="noopener noreferrer"
    className="icon-circle"
  >
    <FaYoutube />
  </a>

</div>
      </div>
    <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Transaction Analysts. All Rights Reserved.</p>
      </div>

      <div className="qr-float">
        <button onClick={handleScannerClick} className="qr-button">
          <img
            src={QR_SRC}
            alt="Scan to get the TA Wallet app"
            className="qr-img"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.style.display = "none";
            }}
          />
        </button>
        <p onClick={handleScannerClick}>Get the App</p>
      </div>

      <ChatWithUs />
    </footer>
  );
};

export default FooterSection;



// import React, { useState } from "react";
// import { environmentalURL } from "../environmentalURL";

// import "./FooterSection.css";

// import {
//   FaFacebookF,
//   FaInstagram,
//   FaYoutube,
//   FaXTwitter,
//   FaChevronDown,
// } from "react-icons/fa6";
// import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import ChatWithUs from "./ChatWithUs";

// const FooterSection = () => {
//   const navigate = useNavigate();
//   const [openSection, setOpenSection] = useState(null);
//   const toggleSection = (section) => {
//     setOpenSection(openSection === section ? null : section);
//   };

//   // const handleScannerClick = () => {
//   //   navigate("/generaterq"); // Replace with your route
//   // };
//  const handleScannerClick = () => {
//   const isMobile =
//     /android|iphone|ipad|ipod/i.test(navigator.userAgent) ||
//     window.matchMedia("(max-width: 768px)").matches;

//   if (isMobile) {
//     // Phone: our smart link sends Android -> Play Store, iPhone -> App Store
//     window.location.href = `${environmentalURL}/r/app`;
//   } else {
//     // Desktop: show the page with QR codes
//     navigate("/generaterq");
//   }
// };
//   const QR_SRC = `${environmentalURL}/r/api/qr`;

//   return (
//     <footer className="footer-container">
//       {/* Top Row: 5 Columns */}
//       <div className="footer-topRow">
//         {/* Column 1 */}
//         <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("headOffice")}
//           >
//             Head Office <FaChevronDown className="chevron-icon" />
//           </h4>
//           <div
//             className={`footer-content ${
//               openSection === "headOffice" ? "open" : ""
//             }`}
//           >
//             <p>Transaction Analysts India Pvt Ltd</p>
//             <p>1st floor, Satyam Arcade, 4,</p>
//             <p>BTM 2nd Stage, BTM Layout,</p>
//             <p>Bengaluru, Karnataka - 560076</p>
         
//           </div>
//         </div>

//         {/* Column 2 */}
//         <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("bbps")}
//           >
//             BBPS Business <FaChevronDown className="chevron-icon" />
//           </h4>
//           <ul
//             className={`footer-content ${
//               openSection === "bbps" ? "open" : ""
//             }`}
//           >
//             <li>Mobile Postpaid</li>
//             <li>DTH (Satellite TV)</li>
//             <li>Municipal Taxes</li>
//             <li>Credit Card Bills</li>
//             <li>FASTag Recharge</li>
//             <li>Subscription Fees</li>
//             <li>Electricity Bill</li>
//             <li>LPG Booking</li>
//           </ul>
//         </div>

//         {/* Column 3 */}
//         <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("cards")}
//           >
//             Cards <FaChevronDown className="chevron-icon" />
//           </h4>
//           <ul
//             className={`footer-content ${
//               openSection === "cards" ? "open" : ""
//             }`}
//           >
//             <li>Meals Card</li>
//             <li>Telecom Card</li>
//             <li>Gift Card</li>
//             <li>Travel Card</li>
//             <li>Rupay Card</li>
//             <li>Virtual Card</li>
//             <li>Fuel Card</li>
//             <li>Physical Card</li>
//           </ul>
//         </div>

//         {/* Column 4 */}
//            <div className="footer-column">
//               <h4 className="footer-heading">Contact</h4>
//               <p>
//                 <FaPhoneAlt /> +91-9390358339
//               </p>
//               <p style={{ fontSize: "14px" }}>
//                 <FaEnvelope /> support@taipl.in
//               </p>
//             </div>
//         {/* <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("services")}
//           >
//             Services <FaChevronDown className="chevron-icon" />
//           </h4>
//           <ul
//             className={`footer-content ${
//               openSection === "services" ? "open" : ""
//             }`}
//           >
//             <li>Wallet Features</li>
//             <li>Merchant Solutions</li>
//             <li>Government Schemes</li>
//             <li>Bill Payments</li>
//           </ul>

//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("company")}
//           >
//             Company <FaChevronDown className="chevron-icon" />
//           </h4>
//           <div
//   className={`footer-content ${
//     openSection === "company" ? "open" : ""
//   }`}
// >
//   <p style={{ cursor: "pointer" }} onClick={() => navigate("/aboutus")}>
//     About
//   </p>

//   <p style={{ cursor: "pointer" }} onClick={() => navigate("/career")}>
//     Career
//   </p>
// </div>
//         </div> */}

//         {/* Column 5 */}
//         {/* <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("support")}
//           >
//             Support <FaChevronDown className="chevron-icon" />
//           </h4>
//           <ul
//             className={`footer-content ${
//               openSection === "support" ? "open" : ""
//             }`}
//           >
//             <li>Help Center</li>
//             <li>User Guide</li>
//             <li>Privacy Policy</li>
//             <li>Terms of Service</li>
//           </ul>
//         </div> */}
//       </div>

//       {/* Middle Row */}
//       <div className="footer-middleRow">
//         <div className="footer-logo-wrap">
//           <img
//             src="/assets/images/TransactionAnalysts.png"
//             alt="Transaction Analysts Logo"
//             className="footer-logo-img"
//           />
//         </div>

//         <div className="certifications-wrapper">
//           <h6 className="certifications-heading">
//             Certifications & Compliance
//           </h6>
//           <div className="cert-boxes">
//             <div className="cert-card">
//               <img
//                 src="/assets/images/certificate4.jpg"
//                 alt="ISO 27001:2013"
//                 className="cert-img"
//               />
//             </div>
//             <div className="cert-card">
//               <img
//                 src="/assets/images/certificate5.png"
//                 alt="NPCI Approved"
//                 className="cert-img"
//               />
//             </div>
//             <div className="cert-card">
//               <img
//                 src="/assets/images/certificate6.png"
//                 alt="RBI Compliant"
//                 className="cert-img"
//               />
//             </div>
//           </div>
//         </div>
// <div className="social-icons">
  
//   <a
//     href="https://www.facebook.com/photo/?fbid=167322438522555&set=a.167322405189225"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="icon-circle"
//   >
//     <FaFacebookF />
//   </a>

//   <a
//     href="https://x.com/ta_wallet"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="icon-circle"
//   >
//     <FaXTwitter />
//   </a>

//   <a
//     href="https://www.instagram.com/transactionanalysts?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="icon-circle"
//   >
//     <FaInstagram />
//   </a>

//   <a
//     href="https://www.youtube.com/@TransactionAnalystsIndiaPvtLtd"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="icon-circle"
//   >
//     <FaYoutube />
//   </a>

// </div>
//       </div>
//     <div className="footer-bottom">
//         <p>© 2025 Transaction Analysts. All Rights Reserved.</p>
//       </div>

//       <div className="qr-float">
//         <button onClick={handleScannerClick} className="qr-button">
//        <img
//             src={QR_SRC}
//             alt="Scan to get the TA Wallet app"
//             className="qr-img"
//             onError={(e) => {
//               e.currentTarget.onerror = null;
//               e.currentTarget.style.display = "none";
//             }}
//           />
//         </button>
//         <p onClick={handleScannerClick}>Get the App</p>
//       </div>

//       <ChatWithUs />
//     </footer>
//   );
// };

// export default FooterSection;



// import React, { useState, useEffect } from "react";
// import axios from "axios";

// import "./FooterSection.css";

// import {
//   FaFacebookF,
//   FaInstagram,
//   FaYoutube,
//   FaXTwitter,
//   FaChevronDown,
// } from "react-icons/fa6";
// import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import ChatWithUs from "./ChatWithUs";

// const FooterSection = () => {
//   const navigate = useNavigate();
//   const [openSection, setOpenSection] = useState(null);
//  // ✅ NEW STATE FOR QR
//   const [qrImage, setQrImage] = useState("");
//   const toggleSection = (section) => {
//     setOpenSection(openSection === section ? null : section);
//   };

//   const handleScannerClick = () => {
//     navigate("/generaterq"); // Replace with your route
//   };
//  // ✅ FETCH QR IMAGE
//   useEffect(() => {
//     fetchQr();
//   }, []);

//   const fetchQr = async () => {
//     try {
//       const response = await axios.get(
//         "http://192.168.0.12:8095/taapi/api/qr", // ✅ IMPORTANT
//         { responseType: "blob" }
//       );

//       const imageUrl = URL.createObjectURL(response.data);
//       setQrImage(imageUrl);
//     } catch (error) {
//       console.error("Error fetching QR:", error);
//     }
//   };

//   return (
//     <footer className="footer-container">
//       {/* Top Row: 5 Columns */}
//       <div className="footer-topRow">
//         {/* Column 1 */}
//         <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("headOffice")}
//           >
//             Head Office <FaChevronDown className="chevron-icon" />
//           </h4>
//           <div
//             className={`footer-content ${
//               openSection === "headOffice" ? "open" : ""
//             }`}
//           >
//             <p>Transaction Analysts India Pvt Ltd</p>
//             <p>1st floor, Satyam Arcade, 4,</p>
//             <p>BTM 2nd Stage, BTM Layout,</p>
//             <p>Bengaluru, Karnataka - 560076</p>
         
//           </div>
//         </div>

//         {/* Column 2 */}
//         <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("bbps")}
//           >
//             BBPS Business <FaChevronDown className="chevron-icon" />
//           </h4>
//           <ul
//             className={`footer-content ${
//               openSection === "bbps" ? "open" : ""
//             }`}
//           >
//             <li>Mobile Postpaid</li>
//             <li>DTH (Satellite TV)</li>
//             <li>Municipal Taxes</li>
//             <li>Credit Card Bills</li>
//             <li>FASTag Recharge</li>
//             <li>Subscription Fees</li>
//             <li>Electricity Bill</li>
//             <li>LPG Booking</li>
//           </ul>
//         </div>

//         {/* Column 3 */}
//         <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("cards")}
//           >
//             Cards <FaChevronDown className="chevron-icon" />
//           </h4>
//           <ul
//             className={`footer-content ${
//               openSection === "cards" ? "open" : ""
//             }`}
//           >
//             <li>Meals Card</li>
//             <li>Telecom Card</li>
//             <li>Gift Card</li>
//             <li>Travel Card</li>
//             <li>Rupay Card</li>
//             <li>Virtual Card</li>
//             <li>Fuel Card</li>
//             <li>Physical Card</li>
//           </ul>
//         </div>

//         {/* Column 4 */}
//            <div className="footer-column">
//               <h4 className="footer-heading">Contact</h4>
//               <p>
//                 <FaPhoneAlt /> +91-9390358339
//               </p>
//               <p style={{ fontSize: "14px" }}>
//                 <FaEnvelope /> support@taipl.in
//               </p>
//             </div>
//         {/* <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("services")}
//           >
//             Services <FaChevronDown className="chevron-icon" />
//           </h4>
//           <ul
//             className={`footer-content ${
//               openSection === "services" ? "open" : ""
//             }`}
//           >
//             <li>Wallet Features</li>
//             <li>Merchant Solutions</li>
//             <li>Government Schemes</li>
//             <li>Bill Payments</li>
//           </ul>

//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("company")}
//           >
//             Company <FaChevronDown className="chevron-icon" />
//           </h4>
//           <div
//   className={`footer-content ${
//     openSection === "company" ? "open" : ""
//   }`}
// >
//   <p style={{ cursor: "pointer" }} onClick={() => navigate("/aboutus")}>
//     About
//   </p>

//   <p style={{ cursor: "pointer" }} onClick={() => navigate("/career")}>
//     Career
//   </p>
// </div>
//         </div> */}

//         {/* Column 5 */}
//         {/* <div className="footer-column">
//           <h4
//             className="footer-heading"
//             onClick={() => toggleSection("support")}
//           >
//             Support <FaChevronDown className="chevron-icon" />
//           </h4>
//           <ul
//             className={`footer-content ${
//               openSection === "support" ? "open" : ""
//             }`}
//           >
//             <li>Help Center</li>
//             <li>User Guide</li>
//             <li>Privacy Policy</li>
//             <li>Terms of Service</li>
//           </ul>
//         </div> */}
//       </div>

//       {/* Middle Row */}
//       <div className="footer-middleRow">
//         <div className="footer-logo-wrap">
//           <img
//             src="/assets/images/TransactionAnalysts.png"
//             alt="Transaction Analysts Logo"
//             className="footer-logo-img"
//           />
//         </div>

//         <div className="certifications-wrapper">
//           <h6 className="certifications-heading">
//             Certifications & Compliance
//           </h6>
//           <div className="cert-boxes">
//             <div className="cert-card">
//               <img
//                 src="/assets/images/certificate4.jpg"
//                 alt="ISO 27001:2013"
//                 className="cert-img"
//               />
//             </div>
//             <div className="cert-card">
//               <img
//                 src="/assets/images/certificate5.png"
//                 alt="NPCI Approved"
//                 className="cert-img"
//               />
//             </div>
//             <div className="cert-card">
//               <img
//                 src="/assets/images/certificate6.png"
//                 alt="RBI Compliant"
//                 className="cert-img"
//               />
//             </div>
//           </div>
//         </div>
// <div className="social-icons">
  
//   <a
//     href="https://www.facebook.com/photo/?fbid=167322438522555&set=a.167322405189225"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="icon-circle"
//   >
//     <FaFacebookF />
//   </a>

//   <a
//     href="https://x.com/ta_wallet"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="icon-circle"
//   >
//     <FaXTwitter />
//   </a>

//   <a
//     href="https://www.instagram.com/transactionanalysts?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="icon-circle"
//   >
//     <FaInstagram />
//   </a>

//   <a
//     href="https://www.youtube.com/@TransactionAnalystsIndiaPvtLtd"
//     target="_blank"
//     rel="noopener noreferrer"
//     className="icon-circle"
//   >
//     <FaYoutube />
//   </a>

// </div>
//       </div>
//     <div className="footer-bottom">
//         <p>© 2025 Transaction Analysts. All Rights Reserved.</p>
//       </div>

//       <div className="qr-float">
//         <button onClick={handleScannerClick} className="qr-button">
//        <img src="assets/images/qr.png" alt="QR Code" className="qr-img" />
//         </button>
//         <p onClick={handleScannerClick}>Get the App</p>
//       </div>

//       <ChatWithUs />
//     </footer>
//   );
// };

// export default FooterSection;
